import React, {useState, useCallback, useEffect, useRef}from 'react';
import LoginForm from './components/Login/LoginForm';
import RequestForm from './components/Login/RequestForm';
import Alert from './components/UI/Alert/Alert';
import TextContent from './components/UI/Alert/TextContent';
import LoginFooter from './components/Footer/LoginFooter';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { URL } from './constants';
import parse from 'html-react-parser';

const useMounted = () => {
    const mountedRef = useRef(false);
    const isMounted = useCallback(() => mountedRef.current, []);
    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);
    return isMounted;
};

const Login = props => {
    const isAuth = useSelector(state => state.auth.isAuth);
    const [announcements, setAnnouncements] = useState([]);
    const isMounted = useMounted();

    const requestForms = {
        forgetAccount: {
            id: 'forgetAccount',
            title: '忘記帳號',
            inputLabels: ['使用者姓名：', 'Email：', '驗證碼：'],
            fieldNames: ['name', 'email', 'answer']
        },
        forgetPassword: {
            id: 'forgetPassword',
            title: '忘記密碼',
            inputLabels: ['帳號：', 'Email：', '驗證碼：'],
            fieldNames: ['account', 'email', 'answer']
        },
        unlockAccount: {
            id: 'unlockAccount',
            title: '帳號解鎖',
            inputLabels: ['帳號：', 'Email：', '驗證碼：'],
            fieldNames: ['account', 'email', 'answer']
        }
    };

    const init = useCallback(() => {
        refreshAnnouncements();
    }, []);

    useEffect(() => {
        let unmounted = false;
        refreshAnnouncements();

        return () => {unmounted = true};
    }, [init]);

    const refreshAnnouncements = async () => {
        await fetch(`${URL}/system/announcement/index`, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        }).then(res => res.json()).then(res => {
            if (!isMounted()) {
                return;
            }
            setAnnouncements(res);
        });
    }

    return (
        <div className='Login'>
            {/* If user already sign-in, redirect to home page */}
            {isAuth && <Redirect to='/' />}

            <LoginForm requestForms={requestForms} />

            <LoginFooter />

            <RequestForm {...requestForms.forgetAccount} />
            <RequestForm {...requestForms.forgetPassword} />
            <RequestForm {...requestForms.unlockAccount} />

            {announcements && announcements.length > 0 &&
                <Alert type='alert-warning'>
                    {announcements.map(announcement => {
                        return <TextContent key={announcement.id}>
                                <h1>{announcement.subject}</h1>
                                {parse(announcement.content)}
                            </TextContent>
                    })}
                </Alert>
            }
        </div>
    );
}

export default Login;